import React from "react";
import "../../../public/css/style.less";
import {
  apiBatchRequest,
  apiBatchRequestWithoutLoader,
  apiRequestNoLoadder,
  CancelRequest,
  RenewCancelToken,
} from "../../../utils/api_service";
import { API_URL } from "../../../constants/api";
import ReportButtons from "../../../utils/ReportButtons";
import PageFilter from "../../common/PageFilter";
import { controlType } from "../../../constants/common";
import PageHeader from "../../common/PageHeader";
import { Tooltip } from "@material-ui/core";
import camelcaseKeys from "camelcase-keys";
import SearchBar from "../../common/AutoSearch/SearchBar";
import EditIOSLeaseComps from "./EditIOSLeaseComps";
import { ShowToast, toastType } from "../../../utils/toast-service";
import commonLabels from "../../../constants/messageConstants";
import {
  IsSectionVisible,
  UpdateColumnWithConfiguration,
} from "../../../utils/helper";
import { Operators, SECTIONS } from "../../../constants/appConstants";
import { PaginatedGridTable } from "../../common/Table/PaginatedTable";
import { withRouter } from "react-router-dom";
import { routes } from "../../../constants/routes";

class IOSLeaseComps extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      selectedMarketId: this.props.globalMarketId,
      leaseCompsSummaryData: [],
      configuration: [],
      userConfiguration: [],
      selectedEditRowId: undefined,
      detailView: false,
      ViewTitle: undefined,
      actionType: undefined,
      getSubMarketMaster: [],
      openFilter: false,
      getAllLeaseType: [],
      getMarketMaster: [],
      companyMasterDetails: [],
      propertyNameAddrCostar: [],
      rowsPerPage: 20,
      reloadTable: false,
      enableFilterButton: false,
      selectedValue: null,
      selectedValueId: -1,
      searchInput: "",
      filterSelectedData: [],
      isInAddMode: false,
      pageNumber: 0,
      companyId: "",
      closeDate: "",
      lcd: "",
      lxdte: "",
      rsf: "",
    };
  }

  componentDidMount() {
    RenewCancelToken();
    this.getRequiredData(this.state.selectedMarketId);
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.globalMarketId !== this.state.selectedMarketId) {
      this.getRequiredData(nextProps.globalMarketId);
      this.setState({
        selectedMarketId: nextProps.globalMarketId,
        selectedValue: null,
        selectedValueId: -1,
      });
    }
  }

  componentWillUnmount() {
    CancelRequest();
  }

  getRequiredDataWithoutLoader = (selectedMarketId) => {
    this._asyncRequest = apiBatchRequestWithoutLoader([
      {
        url: API_URL.Master.getAllLeaseType,
        key: "getAllLeaseType",
        params: { businessLineId: 2 },
        fromCache: true,
        duration: 60,
      },
      {
        url: API_URL.Master.getMarketSubmarket,
        key: "getMarketSubmarket",
        params: { businessLineId: 2, marketId: selectedMarketId },
      },
    ])
      .then((response) => {
        this._asyncRequest = null;
        if (response.getMarketSubmarket.submarket.success === true) {
          this.setState({
            getMarketMaster:
              camelcaseKeys(response.getMarketSubmarket.market.data) || [],
            getSubMarketMaster:
              camelcaseKeys(response.getMarketSubmarket.submarket.data) || [],
            getAllLeaseType:
              camelcaseKeys(response.getAllLeaseType.data) || [],
            selectedValueId: !this.props.globalMarketId?.includes?.("|")
              ? this.props.globalMarketId
              : -1,
            enableFilterButton: true,
          });
        } else {
          ShowToast(
            response.getMarketSubmarket.submarket.message,
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  getRequiredData = (selectedMarketId) => {
    if (!selectedMarketId) return;

    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.IOSLeaseComps.iosLeaseCompsSummaryData,
        key: "leaseCompsSummaryData",
        params: {
          marketId: selectedMarketId,
          companyId: this.state.companyId,
          closeDate: this.state.closeDate,
          lcd: this.state.lcd,
          lxdte: this.state.lxdte,
          pageNumber: this.state.pageNumber + 1,
          pageSize: this.state.rowsPerPage,
        },
      },
      {
        url: API_URL.Master.GetUserConfigurations,
        key: "userConfiguration",
        params: { sectionId: SECTIONS.IOS_Lease_Comp_Listing },
        fromCache: true,
        duration: 60,
      },
      {
        url: API_URL.Master.getBuildingNameAddressCostarMaster,
        key: "propertyNameAddrCostar",
        params: {
          businessLineId: 2,
          searchText: null,
          marketId: selectedMarketId,
        },
      },
    ])
      .then((response) => {
        this._asyncRequest = null;
        if (response.leaseCompsSummaryData.success === true) {
          this.getRequiredDataWithoutLoader(selectedMarketId);
          const userConfig =
            response.userConfiguration.data ||
            JSON.parse(window.sessionStorage.getItem("userConfigurations"));
          this.setState({
            leaseCompsSummaryData:
              camelcaseKeys(response.leaseCompsSummaryData.data) || [],
            configuration:
              camelcaseKeys(response.leaseCompsSummaryData.configuration) || [],
            userConfiguration: camelcaseKeys(userConfig) || [],
            rowsPerPage:
              response.userConfiguration.data?.[2]?.rowPerPage || 20,
            propertyNameAddrCostar:
              camelcaseKeys(response.propertyNameAddrCostar.data) || [],
            reloadTable: !this.state.reloadTable,
          });
        } else {
          ShowToast(
            response.leaseCompsSummaryData.message,
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  reloadGridData = (selectedMarketId) => {
    if (!selectedMarketId) return;

    this._asyncRequest = apiBatchRequest([
      {
        url: API_URL.IOSLeaseComps.iosLeaseCompsSummaryData,
        key: "leaseCompsSummaryData",
        params: {
          marketId: selectedMarketId,
          companyId: this.state.companyId,
          closeDate: this.state.closeDate,
          lcd: this.state.lcd,
          lxdte: this.state.lxdte,
          rsf: this.state.rsf,
          pageNumber: this.state.pageNumber + 1,
          pageSize: this.state.rowsPerPage,
        },
      },
    ])
      .then((response) => {
        this._asyncRequest = null;
        if (response.leaseCompsSummaryData.success === true) {
          const rows = camelcaseKeys(response.leaseCompsSummaryData.data) || [];
          this.setState({
            leaseCompsSummaryData: rows,
            reloadTable: !this.state.reloadTable,
          });
        } else {
          ShowToast(
            response.leaseCompsSummaryData.message,
            toastType.ERROR,
            5000,
            500,
            "Server error"
          );
        }
      })
      .catch(() => {
        this._asyncRequest = null;
      });
  };

  reloadData = () => {
    this.reloadGridData(this.state.selectedMarketId);
    this.setState({
      detailView: false,
      selectedEditRowId: undefined,
      companyMasterDetails: [],
      reloadTable: !this.state.reloadTable,
    });
  };

  onFilterChange = (selectedData) => {
    if (selectedData.length > 0) {
      let closeDate = "";
      let lcd = "";
      let lxdte = "";
      let rsf = "";

      for (let i = 0; i < selectedData.length; i++) {
        const selected = selectedData[i].selected ?? [];
        if (selectedData[i].key === "closedate") {
          closeDate = selected.map((item) => item.closedate).join("|");
        }
        if (selectedData[i].key === "lcd") {
          lcd = selected.map((item) => item.lcd).join("|");
        }
        if (selectedData[i].key === "lxDte") {
          lxdte = selected.map((item) => item.lxDte).join("|");
        }
        if (selectedData[i].key === "rsf") {
          rsf = selected.map((item) => item.rsf).join("|");
        }
      }

      this.setState(
        {
          filterSelectedData: [selectedData],
          closeDate,
          lcd,
          lxdte,
          rsf,
          pageNumber: 0,
          reloadTable: !this.state.reloadTable,
        },
        () => this.reloadGridData(this.state.selectedMarketId)
      );
    } else {
      this.resetFilters();
    }
  };

  resetFilters = () => {
    this.setState(
      {
        filterSelectedData: null,
        companyId: "",
        closeDate: "",
        lcd: "",
        lxdte: "",
        rsf: "",
        pageNumber: 0,
        reloadTable: !this.state.reloadTable,
      },
      () => this.reloadGridData(this.state.selectedMarketId)
    );
  };

  onSearchInputChange = (filter, value) => {
    apiRequestNoLoadder({
      url: API_URL.Master.companyMasterDetails,
      params: { businessLineId: 2, searchText: value },
    })
      .then(({ data }) => {
        this.setState({
          companyMasterDetails: camelcaseKeys(data.data || data) || [],
        });
      })
      .catch(() => {
        ShowToast(
          commonLabels.somethingWrong,
          toastType.ERROR,
          5000,
          500,
          "Server error"
        );
      });
  };

  handleSearchChange = (e, value) => {
    const companyId = value?.companyId || "";
    const companyName = value?.companyName || "";
    this.setState(
      {
        searchInput: companyName,
        companyId,
        pageNumber: 0,
        reloadTable: !this.state.reloadTable,
      },
      () => this.reloadGridData(this.state.selectedMarketId)
    );
  };

  onInputChange = () => {};

  renderActionColumn = (cellInfo) => (
    <Tooltip title="View">
      <a
        className="default-text"
        aria-label="viewComp"
        size="small"
        onClick={() => {
          this.setState({ isInAddMode: false });
          this.onRowClick(cellInfo);
        }}
      >
        <span className="default-text span-link">
          {cellInfo.companyName || "---"}
        </span>
      </a>
    </Tooltip>
  );

  onAddNewClick = () => {
    this.setState({
      isInAddMode: true,
      detailView: true,
      selectedEditRowId: undefined,
      ViewTitle: "Add",
      actionType: "Add",
    });
  };

  onRowClick = (data) => {
    this.setState({
      detailView: true,
      selectedEditRowId: data.compId,
      ViewTitle: "Edit",
      actionType: "Edit",
    });
    this.props.history.push(`/${routes.iosleasecomps}/${data.compId}`);
  };

  onBackClick = () => {
    this.setState({ detailView: false, selectedEditRowId: undefined });
    this.props.history.push(`/${routes.iosleasecomps}`);
  };

  reloadPage = (page, rowcount) => {
    this.setState(
      {
        pageNumber: page,
        rowsPerPage: rowcount,
        reloadTable: !this.state.reloadTable,
      },
      () => this.reloadGridData(this.state.selectedMarketId)
    );
  };

  handleCheck = (key) =>
    (this.state.userConfiguration?.length > 0
      ? this.state.userConfiguration
      : this.state.configuration || []
    ).some(
      (item) =>
        ((item.key || item.dbColumn || "").toLowerCase() === key.toLowerCase()) &&
        item.isVisible === true
    );

  enableFilter = () => {
    const openFilter = this.state.openFilter;
    this.setState({ openFilter: !openFilter });
  };

  render() {
    const {
      leaseCompsSummaryData,
      userConfiguration,
      getMarketMaster,
      getSubMarketMaster,
      getAllLeaseType,
      searchInput,
      detailView,
      selectedEditRowId,
      configuration,
      openFilter,
    } = this.state;

    const userConfigSource = 
      userConfiguration?.length > 0
        ? userConfiguration
        : (configuration || []).map((item) => ({
          ...item,
          key: item.key || item.dbColumn,
        }));  

    const userConfig = (userConfigSource || []).map((item) => {
      const column = { ...item };

      if ((column.key || "").toLowerCase() === "companyname") {
        column.renderComponent = "renderActionColumn";
      }

      return column;
    }).sort((a, b) =>
      a.attributeSortOrder > b.attributeSortOrder ? 1 : -1
    );
    const assignedMarkets = this.props.userConfig?.userMarket || [];
    const { compId = -1 } = this.props.match?.params || -1;

    if (compId && compId != -1 && !detailView) {
      this.setState({
        selectedEditRowId: compId,
        ViewTitle: "Edit",
        actionType: "Edit",
        detailView: true,
        isInAddMode: false,
      });
    }

    if (compId && detailView) {
      return (
        <EditIOSLeaseComps
          globalMarketId={this.props.globalMarketId}
          selectedCompId={selectedEditRowId}
          onBackClick={this.onBackClick}
          ViewTitle={this.state.ViewTitle}
          actionType={this.state.actionType}
          isInAddMode={this.state.isInAddMode}
          reloadData={this.reloadData}
          companyMasterDetails={this.state.companyMasterDetails}
          getBuildingMaster={this.state.propertyNameAddrCostar}
          onMarketChange={this.props.onMarketChange}
          assignedMarkets={assignedMarkets}
          getSubMarketMaster={getSubMarketMaster}
          getMarketMaster={getMarketMaster}
        />
      );
    }

    if (detailView) {
      return (
        <EditIOSLeaseComps
          globalMarketId={this.props.globalMarketId}
          selectedCompId={selectedEditRowId}
          onBackClick={this.onBackClick}
          ViewTitle={this.state.ViewTitle}
          actionType={this.state.actionType}
          isInAddMode={this.state.isInAddMode}
          reloadData={this.reloadData}
          companyMasterDetails={this.state.companyMasterDetails}
          getBuildingMaster={this.state.propertyNameAddrCostar}
          onMarketChange={this.props.onMarketChange}
          assignedMarkets={assignedMarkets}
          getSubMarketMaster={getSubMarketMaster}
          getMarketMaster={getMarketMaster}
        />
      );
    }

    return (
      <>
        <div className="row no-print">
          <div className="col-md-3 col-lg-3">
            <PageHeader title="IOS Lease Comps" />
          </div>
          <div className="col-md-9 col-lg-9">
            <div className="row">
              <div className="col-md-6 col-lg-6">
                <SearchBar
                  size="large"
                  name="searchInput"
                  value={searchInput || ""}
                  label="Search"
                  placeholder="Search tenant"
                  searchInput={searchInput}
                  companyMasterDetails={this.state.companyMasterDetails}
                  isOwner={true}
                  handleChange={this.handleSearchChange}
                  onInputChange={this.onSearchInputChange}
                  reloadData={this.resetFilters}
                />
              </div>
              <div className="col-md-3 col-lg-3"></div>
              <div className="col-md-3 col-lg-3">
                <ReportButtons
                  resetPage={[]}
                  openFilter={this.state.openFilter}
                  enableFilter={this.enableFilter}
                  handleSubmit={[]}
                  data={leaseCompsSummaryData}
                  fileName={"IOSLeaseComps.xlsx"}
                  enableFilterButton={this.state.enableFilterButton}
                  ParentSection={SECTIONS.IOS_Lease_Comps}
                />
              </div>
            </div>
          </div>
        </div>

        {leaseCompsSummaryData && userConfig.length > 0 && (
          <div className="row" style={{ marginTop: "0px" }}>
            <div className="col-sm-12 col-lg-12">
              <PageFilter
                onInputChange={this.onInputChange}
                resetFilters={this.resetFilters}
                autoFilter={true}
                openAppliedFilterPane={true}
                filterSelectedData={this.state.filterSelectedData}
                filterApplied={true}
                filterAlwaysVisible={openFilter}
                openFilter={true}
                onFilterChanged={this.onFilterChange}
                filterConfig={[
                  {
                    multiple: true,
                    type: controlType.DropDown,
                    source: [
                      ...new Map(
                        getSubMarketMaster.map((item) => [item.subMarket, item])
                      ).values(),
                    ],
                    key: "subMarket",
                    placeholder: "",
                    title: "Sub Market",
                    isVisible: this.handleCheck("subMarket"),
                  },
                  {
                    multiple: true,
                    type: controlType.DropDown,
                    source: getAllLeaseType,
                    key: "leaseType",
                    placeholder: "",
                    title: "Negotiation Type",
                    isVisible: this.handleCheck("leaseType"),
                  },
                  {
                    multiple: true,
                    type: controlType.DateRangePicker,
                    key: "closedate",
                    placeholder: "",
                    title: "Close Date",
                    isVisible: this.handleCheck("closedate"),
                    operator: [
                      Operators.GreaterThanEqualsTo,
                      Operators.LessThanEqualsTo,
                    ],
                  },
                  {
                    multiple: true,
                    type: controlType.DateRangePicker,
                    key: "lcd",
                    placeholder: "",
                    title: "Lease Commencement Date",
                    isVisible: this.handleCheck("lcd"),
                    operator: [
                      Operators.GreaterThanEqualsTo,
                      Operators.LessThanEqualsTo,
                    ],
                  },
                  {
                    multiple: true,
                    type: controlType.DateRangePicker,
                    key: "lxDte",
                    placeholder: "",
                    title: "Lease Expiration Date",
                    isVisible: this.handleCheck("lxDte"),
                    operator: [
                      Operators.GreaterThanEqualsTo,
                      Operators.LessThanEqualsTo,
                    ],
                  },
                ]}
                defaultSelectedData={[]}
                selectedData={[]}
                gridColumn={4}
              />
            </div>
          </div>
        )}

        {leaseCompsSummaryData && userConfig.length > 0 && (
          <div className="row" style={{ marginTop: "0px" }}>
            <div className="col-sm-12 col-lg-12">
              <PaginatedGridTable
                validationMessage={[]}
                rowCount={this.state.rowsPerPage > 0 ? this.state.rowsPerPage : 20}
                columns={UpdateColumnWithConfiguration(
                  userConfig,
                  configuration,
                  []
                )}
                selectedEditRowId={selectedEditRowId}
                data={leaseCompsSummaryData}
                renderActionColumn={this.renderActionColumn}
                reload={this.state.reloadTable}
                config={userConfig}
                AddNewRecord={{
                  action: this.onAddNewClick,
                  title: "Add IOS Lease Comp",
                  visible: IsSectionVisible(
                    SECTIONS.IOS_Lease_Comps,
                    SECTIONS.IOS_Lease_Comp_Listing,
                    SECTIONS.ADD_EDIT
                  ),
                }}
                reloadPaginatedData={this.reloadPage}
                pageNumber={this.state.pageNumber}
              />
            </div>
          </div>
        )}
      </>
    );
  }
}

export default withRouter(IOSLeaseComps);
